// extracted by mini-css-extract-plugin
export default {"table":"Table_table__mIQO9","cols2Td":"Table_cols2Td__6k75V","cols3Td":"Table_cols3Td__kq5VC","tr":"Table_tr__WR-6E","td":"Table_td__nRAJD"};